
export function getLeafCols(leafNodes, obj) {
    if (obj.columns) {
      obj.columns.forEach(function(child) {
        getLeafCols(leafNodes, child)
      })
    } else {
      leafNodes.push(obj.id ?? "")
    }
  }
  